import type { FC } from "react";
import { cn } from "@/lib/cn";

interface LoadingSpinnerProps {
  className?: string;
  "aria-label"?: string;
}

export const LoadingSpinner: FC<LoadingSpinnerProps> = ({
  className,
  "aria-label": ariaLabel = "Loading",
}) => (
  <div
    role="status"
    aria-label={ariaLabel}
    className={cn("flex items-center justify-center p-8", className)}
  >
    <div className="h-8 w-8 animate-spin rounded-full border-4 border-white/10 border-t-brand" />
  </div>
);
